/* PixelPilot storefront snippet — GENERATED by scripts/build-theme-snippet.js.
 * Do not edit here; edit shared/applyRecipe.js + docs/theme-capture-snippet.js and rebuild.
 * Deploy this file as theme asset assets/pixelpilot-capture.js (replace aa805d50005bbfa1e4f3043dbaae57e6).
 *
 * oxlint no-undef is ignored for this file (see .oxlintrc.json's
 * ignorePatterns): it runs inside a Shopify theme <script> tag, where
 * `Shopify` and `webVitals` are real runtime globals injected by the theme
 * and the Web Vitals library respectively — not undefined references, just
 * globals this repo's lint environment has no way to know about.
 */
/* ==== shared/applyRecipe.js (window.PixelPilotRecipe) ==== */
/*
 * shared/applyRecipe.js — THE single recipe-application implementation.
 *
 * Consumed by BOTH the editor's live preview (imported by the React CROView
 * editor) AND the storefront theme script (inlined into the deploy snippet).
 * Preview and production apply variants through this exact code so they can
 * never diverge. UMD wrapper so it works as an ES/CJS import and as a browser
 * global (window.PixelPilotRecipe).
 *
 * Safety model (the XSS boundary is here + croRecipe.js server validation):
 *   - text is written via textContent (markup is inert)
 *   - attributes via setAttribute, with a defensive client-side javascript:/data:
 *     re-check even though the server already validated
 *   - NO innerHTML with recipe strings, ever
 *   - fingerprint mismatch → skip that op (log); if the op is priceElement, the
 *     WHOLE recipe is aborted (nothing applied) — carried from the price-testing
 *     fail-closed rule.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PixelPilotRecipe = factory();
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Stable-ish fingerprint captured at edit time and re-checked at apply time:
  // trimmed textContent (first 40 chars) for text-bearing elements, else a
  // tag/id/class/src signature.
  function fingerprint(el) {
    if (!el || !el.tagName) return '';
    var txt = (el.textContent || '').trim().replace(/\s+/g, ' ');
    if (txt) return txt.slice(0, 40);
    var tag = el.tagName.toLowerCase();
    var id = el.id ? '#' + el.id : '';
    var cls = (typeof el.className === 'string' && el.className.trim())
      ? '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.') : '';
    var url = (el.getAttribute && (el.getAttribute('src') || el.getAttribute('href'))) || '';
    return (tag + id + cls + '|' + url).slice(0, 80);
  }

  function fpMatch(el, op) {
    if (op.fingerprint == null || op.fingerprint === '') return true; // none captured → allow
    return fingerprint(el) === op.fingerprint;
  }

  function qa(root, sel) {
    try { return Array.prototype.slice.call(root.querySelectorAll(sel)); } catch (e) { return []; }
  }
  function one(root, sel) { try { return root.querySelector(sel); } catch (e) { return null; } }

  function urlOk(v) {
    if (typeof v !== 'string') return false;
    var s = v.trim();
    var m = /^([a-z][a-z0-9+.-]*):/i.exec(s);
    if (m) return /^https$/i.test(m[1]);       // absolute → https only
    return true;                                // relative / root-relative / anchor
  }

  function deviceGate(op, device) {
    if (!op.device || !device) return true;      // no per-device flag → apply everywhere
    return op.device === device;
  }

  function applyOne(root, op, ctx) {
    var els, i, el, parent;
    switch (op.op) {
      case 'setText':
        els = qa(root, op.selector);
        for (i = 0; i < els.length; i++) { if (fpMatch(els[i], op)) els[i].textContent = op.value; else ctx.skipped.push(op); }
        return els.length > 0;
      case 'setStyle':
        els = qa(root, op.selector);
        for (i = 0; i < els.length; i++) {
          if (!fpMatch(els[i], op)) { ctx.skipped.push(op); continue; }
          for (var p in op.styles) { if (Object.prototype.hasOwnProperty.call(op.styles, p)) { try { els[i].style.setProperty(p, op.styles[p]); } catch (e) {} } }
        }
        return els.length > 0;
      case 'setAttr':
        els = qa(root, op.selector);
        for (i = 0; i < els.length; i++) {
          if (!fpMatch(els[i], op)) { ctx.skipped.push(op); continue; }
          if ((op.attr === 'src' || op.attr === 'href') && !urlOk(op.value)) { ctx.skipped.push(op); continue; }
          try { els[i].setAttribute(op.attr, op.value); } catch (e) {}
        }
        return els.length > 0;
      case 'hide':
        els = qa(root, op.selector);
        for (i = 0; i < els.length; i++) { if (fpMatch(els[i], op)) els[i].style.setProperty('display', 'none', 'important'); else ctx.skipped.push(op); }
        return els.length > 0;
      case 'show':
        els = qa(root, op.selector);
        for (i = 0; i < els.length; i++) { if (fpMatch(els[i], op)) { els[i].style.removeProperty('display'); if (getComputedStyle && getComputedStyle(els[i]).display === 'none') els[i].style.setProperty('display', 'block'); } else ctx.skipped.push(op); }
        return els.length > 0;
      case 'remove':
        els = qa(root, op.selector);
        for (i = 0; i < els.length; i++) { if (fpMatch(els[i], op) && els[i].parentNode) els[i].parentNode.removeChild(els[i]); else ctx.skipped.push(op); }
        return els.length > 0;
      case 'reorder':
        parent = one(root, op.parentSelector);
        if (!parent) return false;
        var kids = Array.prototype.slice.call(parent.children);
        for (i = 0; i < op.order.length; i++) { var k = kids[op.order[i]]; if (k) parent.appendChild(k); }
        return true;
      case 'duplicate':
        el = one(root, op.selector);
        if (!el || !el.parentNode || !fpMatch(el, op)) { if (el) ctx.skipped.push(op); return false; }
        var clone = el.cloneNode(true);
        if (op.position === 'before') el.parentNode.insertBefore(clone, el);
        else el.parentNode.insertBefore(clone, el.nextSibling);
        return true;
      default:
        return false;
    }
  }

  /*
   * applyRecipe(root, recipe, opts) → { applied, skipped, aborted, abortReason }
   * opts.device: 'mobile'|'desktop' (per-device op gating via the op.device flag).
   * Price safety: if any priceElement op's target fingerprint mismatches, abort
   * the ENTIRE recipe before mutating anything (fail closed to the real page).
   *
   * GOVERNING INVARIANT (Phase B price testing): a discounted price is NEVER shown
   * before the matching cart discount is confirmed applied — any failure shows the
   * real price. This module only guards the DOM apply (the fingerprint abort above);
   * the confirm-before-reveal step lives in the serving snippet
   * (server/docs/theme-capture-snippet.js). A priceElement op carries price.base
   * (real) and price.test (intended) so that snippet can verify the cart charges
   * price.test before revealing. Do NOT reveal a priceElement recipe on apply alone.
   */
  function applyRecipe(root, recipe, opts) {
    opts = opts || {};
    var ctx = { skipped: [], applied: 0 };
    if (!root || !Array.isArray(recipe)) return { applied: 0, skipped: [], aborted: false };

    // Pre-check: any priceElement op whose target is missing or fingerprint-
    // mismatched aborts the whole recipe (never show a wrong price).
    for (var i = 0; i < recipe.length; i++) {
      var op = recipe[i];
      if (op && op.priceElement) {
        var sel = op.selector || op.parentSelector;
        var target = sel ? one(root, sel) : null;
        if (!target || !fpMatch(target, op)) {
          return { applied: 0, skipped: [], aborted: true, abortReason: 'price element fingerprint mismatch: ' + sel };
        }
      }
    }

    for (var j = 0; j < recipe.length; j++) {
      var o = recipe[j];
      if (!o || !deviceGate(o, opts.device)) continue;
      try { if (applyOne(root, o, ctx)) ctx.applied++; }
      catch (e) { ctx.skipped.push(o); }
    }
    return { applied: ctx.applied, skipped: ctx.skipped, aborted: false };
  }

  return { applyRecipe: applyRecipe, fingerprint: fingerprint };
}));
/* ==== web-vitals (npm: web-vitals, attribution IIFE build, vendored verbatim) ==== */
var webVitals=function(t){"use strict";class n{t;o=0;i=[];l(t){if(t.hadRecentInput)return;const n=this.i[0],e=this.i.at(-1);this.o&&n&&e&&t.startTime-e.startTime<1e3&&t.startTime-n.startTime<5e3?(this.o+=t.value,this.i.push(t)):(this.o=t.value,this.i=[t]),this.t?.(t)}}const e=()=>{const t=performance.getEntriesByType("navigation")[0];if(t&&t.responseStart>0&&t.responseStart<performance.now())return t},o=t=>{if("loading"===document.readyState)return"loading";const n=e();if(n){if(t<n.domInteractive)return"loading";if(0===n.domContentLoadedEventStart||t<n.domContentLoadedEventStart)return"dom-interactive";if(0===n.domComplete||t<n.domComplete)return"dom-content-loaded"}return"complete"},i=t=>{const n=t.nodeName;return 1===t.nodeType?n.toLowerCase():n.toUpperCase().replace(/^#/,"")},a=t=>{let n="";try{for(;9!==t?.nodeType;){const e=t,o=e.id?"#"+e.id:[i(e),...Array.from(e.classList??[]).sort()].join(".");if(n.length+o.length>99)return n||o;if(n=n?o+">"+n:o,e.id)break;t=e.parentNode}}catch{}return n},r=new WeakMap;function s(t,n){let e=r.get(n);return e||(e=new WeakMap,r.set(n,e)),e.get(t)||e.set(t,new n),e.get(t)}let c=-1;const f=()=>c,l=t=>{addEventListener("pageshow",n=>{n.persisted&&(c=n.timeStamp,t(n))},!0)},u=(t,n,e,o)=>{let i,a;return r=>{n.value>=0&&(r||o)&&(a=n.value-(i??0),(a||void 0===i)&&(i=n.value,n.delta=a,n.rating=((t,n)=>t>n[1]?"poor":t>n[0]?"needs-improvement":"good")(n.value,e),t(n)))}},d=t=>{requestAnimationFrame(()=>requestAnimationFrame(()=>t()))},h=()=>e()?.activationStart??0;let g=-1;const v=new Set,p=()=>"hidden"!==document.visibilityState||document.prerendering?1/0:0,m=t=>{if("hidden"===document.visibilityState){if("visibilitychange"===t.type)for(const t of v)t();isFinite(g)||(g="visibilitychange"===t.type?t.timeStamp:0,removeEventListener("prerenderingchange",m,!0))}},y=(t=!1)=>{if(t&&(g=1/0),g<0){const t=h(),n=document.prerendering?void 0:globalThis.performance.getEntriesByType("visibility-state").find(n=>"hidden"===n.name&&n.startTime>=t)?.startTime;g=n??p(),addEventListener("visibilitychange",m,!0),addEventListener("prerenderingchange",m,!0),l(()=>{setTimeout(()=>{g=p()})})}return{get firstHiddenTime(){return g},onHidden(t){v.add(t)}}},b=(t,n=-1,o,i=0,a,r,s)=>{const c=e(),l=c?.navigationId||0;let u="navigate";o?u=o:f()>=0?u="back-forward-cache":c&&(document.prerendering||h()>0?u="prerender":document.wasDiscarded?u="restore":c.type&&(u=c.type.replace(/_/g,"-")));return{name:t,value:n,rating:"good",delta:0,entries:[],id:`v6-${Date.now()}-${Math.floor(8999999999999*Math.random())+1e12}`,navigationType:u,navigationId:i||l,navigationInteractionId:a,navigationURL:r||c?.name,navigationStartTime:s||0}},M=(t,n,e={})=>{try{const o=t.filter(t=>PerformanceObserver.supportedEntryTypes.includes(t));if(o.length>0){const t=new PerformanceObserver(t=>{queueMicrotask(()=>{const e=t.getEntries();o.length>1&&e.sort((t,n)=>t.startTime+t.duration-(n.startTime+n.duration)),n(e)})});for(const n of o)t.observe({type:n,buffered:!0,...e});return t}}catch{}},T=t=>globalThis.PerformanceObserver?.supportedEntryTypes?.includes("soft-navigation")&&"function"==typeof globalThis.PerformanceSoftNavigation?.prototype?.getLargestInteractionContentfulPaint&&t&&t.reportSoftNavs,E=(t,n)=>{if(t.set(n.navigationId,n),t.size>2){const n=t.keys().next().value;void 0!==n&&t.delete(n)}},D=t=>{let n=!1;return()=>{n||(t(),n=!0)}};class w{u}const S=t=>{document.prerendering?addEventListener("prerenderingchange",t,!0):t()},k=[1800,3e3],L=(t,n={})=>{const e=T(n);S(()=>{const o=s(n,w),i=y();let a,r=b("FCP");const c=M(["paint"],t=>{for(const n of t)"first-contentful-paint"===n.name&&(c.disconnect(),n.startTime<i.firstHiddenTime&&(r.value=Math.max(n.startTime-h(),0),r.entries.push(n),r.navigationId=n.navigationId||r.navigationId,a(!0)))});if(c&&(a=u(t,r,k,n.reportAllChanges),l(e=>{r=b("FCP",-1,"back-forward-cache",r.navigationId,r.navigationInteractionId,r.navigationURL,f()),a=u(t,r,k,n.reportAllChanges),d(()=>{r.value=performance.now()-e.timeStamp,a(!0)})})),e){M(["soft-navigation"],e=>{e.forEach(e=>{o.u&&e.navigationId&&E(o.u,e);const i=Math.max((e.presentationTime||e.paintTime||0)-e.startTime,0);r=b("FCP",i,"soft-navigation",e.navigationId,e.interactionId,e.name,e.startTime),a=u(t,r,k,n.reportAllChanges),a(!0)})},n)}})},P=[.1,.25],F=t=>t.find(t=>1===t.node?.nodeType)||t[0];let _=0,C=1/0,I=0;const B=t=>{for(const n of t)n.interactionId&&(C=Math.min(C,n.interactionId),I=Math.max(I,n.interactionId),_=I?(I-C)/7+1:0)};let O;const j=()=>O?_:performance.interactionCount??0,A=()=>{"interactionCount"in performance||O||(O=M(["event"],B,{durationThreshold:0}))};class N{h=0;v=[];p=new Map;m;M;T(){return j()-this.h}D(){this.h=j(),this.v.length=0,this.p.clear()}S(t){const n=this.T(),e=Math.min(this.v.length-1,Math.floor(n/50));return!n||-1!==e||"soft-navigation"!==t&&"back-forward-cache"!==t?this.v[e]:{k:8,id:-1,entries:[]}}l(t){if(this.m?.(t),!t.interactionId)return;const n=this.v.at(-1);let e=this.p.get(t.interactionId);if(e||this.v.length<10||t.duration>n.k){if(e?t.duration>e.k?(e.entries=[t],e.k=t.duration):t.duration===e.k&&t.startTime===e.entries[0].startTime&&e.entries.push(t):(e={id:t.interactionId,entries:[t],k:t.duration},this.p.set(e.id,e),this.v.push(e)),this.v.sort((t,n)=>n.k-t.k),this.v.length>10){const t=this.v.splice(10);for(const n of t)this.p.delete(n.id)}this.M?.(e)}}}const q=t=>{const n="requestIdleCallback"in globalThis?1e3:0,e=globalThis.requestIdleCallback||setTimeout,o=globalThis.cancelIdleCallback||clearTimeout;if("hidden"===document.visibilityState)t();else{const i=D(t);let a=-1;const r=()=>{o(a),i()};addEventListener("visibilitychange",r,{once:!0,capture:!0}),a=e(()=>{removeEventListener("visibilitychange",r,{capture:!0}),i()},{timeout:n})}},W=[200,500];class R{m;u;l(t){this.m?.(t)}}const U=[2500,4e3];let V=50;const $=[];M(["resource"],t=>{for(const n of t)$.push(n),$.length>V&&$.shift()});const x=[800,1800],H=t=>{document.prerendering?S(()=>H(t)):"complete"!==document.readyState?addEventListener("load",()=>H(t),!0):setTimeout(t)};return t.CLSThresholds=P,t.FCPThresholds=k,t.INPThresholds=W,t.LCPThresholds=U,t.TTFBThresholds=x,t.onCLS=(t,e={})=>{const i=s(e=Object.assign({},e),n),r=new WeakMap;i.t=t=>{if(t?.sources?.length){const n=F(t.sources),o=n?.node;if(o){const t=e.generateTarget?.(o)??a(o);r.set(n,t)}}};((t,e={})=>{const o=y();L(D(()=>{let i,a=b("CLS",0);const r=s(e,n),c=(n,o,s,c,f)=>{a=b("CLS",0,n,o,s,c,f),r.o=0,i=u(t,a,P,e.reportAllChanges)},h=(t=!1)=>{r.o>a.value&&(a.value=r.o,a.entries=r.i),i(t)},g=t=>{h(!0),c("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime)},v=t=>{for(const n of t)"soft-navigation"!==n.entryType?r.l(n):g(n);h()},p=["layout-shift"];T(e)&&p.push("soft-navigation");const m=M(p,v);m&&(i=u(t,a,P,e.reportAllChanges),o.onHidden(()=>{v(m.takeRecords()),i(!0)}),l(()=>{c("back-forward-cache",a.navigationId,a.navigationInteractionId,a.navigationURL,f()),d(i)}),setTimeout(i))}))})(n=>{t((t=>{let n={};if(t.entries.length){const e=t.entries.reduce((t,n)=>t.value>n.value?t:n);if(e?.sources?.length){const t=F(e.sources);t&&(n={largestShiftTarget:r.get(t),largestShiftTime:e.startTime,largestShiftValue:e.value,largestShiftSource:t,largestShiftEntry:e,loadState:o(e.startTime)})}}return Object.assign(t,{attribution:n})})(n))},e)},t.onFCP=(t,n={})=>{const i=s(n=Object.assign({},n),w);T(n)&&(i.u=new Map);L(n=>{t((t=>{let n={timeToFirstByte:0,firstByteToFCP:t.value,loadState:o(f())};if("soft-navigation"!==t.navigationType){if(t.entries.length){const i=e(),a=t.entries.at(-1);if(i){const e=i.responseStart,r=i.activationStart||0,s=Math.max(0,e-r);n={timeToFirstByte:s,firstByteToFCP:t.value-s,loadState:o(t.entries[0].startTime),navigationEntry:i,fcpEntry:a}}}}else{const e=i.u?.get(t.navigationId);e&&(n={timeToFirstByte:0,firstByteToFCP:t.value,loadState:"complete",navigationEntry:e})}return Object.assign(t,{attribution:n})})(n))},n)},t.onINP=(t,n={})=>{const e=s(n=Object.assign({},n),N);let i=[],r=[],c=0;const d=new WeakMap,h=new WeakMap;let g=!1;const v=()=>{g||(q(p),g=!0)},p=()=>{const t=new Set(e.v.map(t=>d.get(t.entries[0]))),n=r.length-10;r=r.filter((e,o)=>o>=n||t.has(e));const o=new Set;for(const t of r){const n=m(t.startTime,t.processingEnd);for(const t of n)o.add(t)}const a=i.length-10;i=i.filter((t,n)=>o.has(t)||n>=a&&t.startTime>c),g=!1};e.m=t=>{const e=t.startTime+t.duration;let o;c=Math.max(c,t.processingEnd);for(let i=r.length-1;i>=0;i--){const a=r[i];if(Math.abs(e-a.renderTime)<=8){o=a,o.startTime=Math.min(t.startTime,o.startTime),o.processingStart=Math.min(t.processingStart,o.processingStart),o.processingEnd=Math.max(t.processingEnd,o.processingEnd),n.includeProcessedEventEntries&&o.entries.push(t);break}}o||(o={startTime:t.startTime,processingStart:t.processingStart,processingEnd:t.processingEnd,renderTime:e,entries:n.includeProcessedEventEntries?[t]:[]},r.push(o)),t.interactionId&&d.set(t,o),v()},e.M=t=>{if(!h.get(t)){const e=t.entries.find(t=>t.target)?.target;if(e){const o=n.generateTarget?.(e)??a(e);h.set(t,o)}else{const n=t.entries.find(t=>t.targetSelector)?.targetSelector;n&&h.set(t,n)}}};const m=(t,n)=>{const e=[];for(const o of i)if(!(o.startTime+o.duration<t)){if(o.startTime>n)break;e.push(o)}return e},E=t=>{if(0===t.entries.length){const n=t.navigationStartTime||0,e={processedEventEntries:[],longAnimationFrameEntries:[],inputDelay:0,processingDuration:0,presentationDelay:t.value,loadState:o(n)};return Object.assign(t,{attribution:e})}const n=t.entries[0],i=d.get(n),a=Math.max(i.processingStart,n.startTime),r=Math.max(n.startTime+n.duration,a),s=Math.min(i.processingEnd,r),c=i.entries.sort((t,n)=>t.processingStart-n.processingStart),f=m(n.startTime,s),l=e.p.get(n.interactionId),u={interactionTarget:h.get(l),interactionType:n.name.startsWith("key")?"keyboard":"pointer",interactionTime:n.startTime,nextPaintTime:r,processedEventEntries:c,longAnimationFrameEntries:f,inputDelay:a-n.startTime,processingDuration:s-a,presentationDelay:r-s,loadState:o(n.startTime),longestScript:void 0,totalScriptDuration:void 0,totalStyleAndLayoutDuration:void 0,totalPaintDuration:void 0,totalUnattributedDuration:void 0};return(t=>{const n=t.interactionTime,e=t.nextPaintTime;if(!t.longAnimationFrameEntries?.length||!n||!e)return;const o=t.inputDelay,i=t.processingDuration;let a,r,s=0,c=0,f=0,l=0;for(const e of t.longAnimationFrameEntries){c=c+e.startTime+e.duration-e.styleAndLayoutStart;for(const t of e.scripts){const e=t.startTime+t.duration;if(e<n)continue;const f=e-Math.max(n,t.startTime),u=t.duration?f/t.duration*t.forcedStyleAndLayoutDuration:0;s+=f-u,c+=u,f>l&&(r=t.startTime<n+o?"input-delay":t.startTime>=n+o+i?"presentation-delay":"processing-duration",a=t,l=f)}}const u=t.longAnimationFrameEntries.at(-1),d=u?u.startTime+u.duration:0;d>=n+o+i&&(f=e-d),a&&r&&(t.longestScript={entry:a,subpart:r,intersectingDuration:l}),t.totalScriptDuration=s,t.totalStyleAndLayoutDuration=c,t.totalPaintDuration=f,t.totalUnattributedDuration=e-n-s-c-f})(u),Object.assign(t,{attribution:u})};M(["long-animation-frame"],t=>{i=i.concat(t),v()},n),((t,n={})=>{if(!globalThis.PerformanceEventTiming||!("interactionId"in PerformanceEventTiming.prototype))return;const e=y();S(()=>{A();let o,i=b("INP");const a=s(n,N),r=(e,r,s,c,f)=>{a.D(),i=b("INP",-1,e,r,s,c,f),o=u(t,i,W,n.reportAllChanges)},c=()=>{const t=a.S(i.navigationType);t&&t.k!==i.value&&(i.value=t.k,i.entries=t.entries,o())},d=t=>{c(),o(!0),r("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime)},h=(t,n=!1)=>{q(()=>{for(const n of t)"soft-navigation"!==n.entryType?a.l(n):d(n);c(),n&&o(!0)})},g=["event","first-input"];T(n)&&g.push("soft-navigation");const v=M(g,h,{...n,durationThreshold:n.durationThreshold??40});o=u(t,i,W,n.reportAllChanges),v&&(e.onHidden(()=>{h(v.takeRecords(),!0)}),l(()=>{r("back-forward-cache",i.navigationId,i.navigationInteractionId,i.navigationURL,f())}))})})(n=>{t(E(n))},n)},t.onLCP=(t,n={})=>{null!=(n=Object.assign({},n)).resourceBufferSize&&(V=n.resourceBufferSize);const o=s(n,R),i=new WeakMap;T(n)&&(o.u=new Map),o.m=t=>{const e=t.element;if(e){const o=n.generateTarget?.(e)??a(e);i.set(t,o)}else t.id&&i.set(t,`#${t.id}`)};((t,n={})=>{let e=!1;const o=T(n);S(()=>{let i,a=y(),r=b("LCP");const c=s(n,R),g=(o,s,c,f,l)=>{r=b("LCP",-1,o,s,c,f,l),i=u(t,r,U,n.reportAllChanges),e=!1,"soft-navigation"===o&&(a=y(!0))},v=t=>{c.u&&t.navigationId&&E(c.u,t),e||i(!0),g("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime);const n=t.getLargestInteractionContentfulPaint?.();n&&p([n])},p=t=>{n.reportAllChanges||o||(t=t.slice(-1));for(const n of t){if(!n)continue;if("soft-navigation"===n.entryType){v(n);continue}let t=0,e=[],o=n.startTime;if("largest-contentful-paint"===n.entryType)t=Math.max(n.startTime-h(),0),c.l(n),e=[n];else if("interaction-contentful-paint"===n.entryType){const i=n;if(!r.navigationId)continue;if("interactionId"in i&&i.interactionId!=r.navigationInteractionId)continue;o=i.largestContentfulPaint?.renderTime||0,t=Math.max(o-n.startTime,0),i.largestContentfulPaint&&(c.l(i.largestContentfulPaint),e=[i.largestContentfulPaint])}o<a.firstHiddenTime&&(r.value=t,r.entries=e,i())}},m=["largest-contentful-paint"];o&&m.push("interaction-contentful-paint","soft-navigation");const T=M(m,p);if(T){i=u(t,r,U,n.reportAllChanges);const a=["keydown","click","visibilitychange"],s=t=>{if(t.isTrusted&&!e){const t=r.id;q(()=>{if(!e){if(!o){T.disconnect();for(const t of a)removeEventListener(t,s,{capture:!0})}t===r.id&&(e=!0,i(!0))}})}};for(const t of a)addEventListener(t,s,{capture:!0});l(o=>{g("back-forward-cache",r.navigationId,r.navigationInteractionId,r.navigationURL,f()),i=u(t,r,U,n.reportAllChanges),d(()=>{r.value=performance.now()-o.timeStamp,e=!0,i(!0)})})}})})(n=>{t((t=>{let n={timeToFirstByte:0,resourceLoadDelay:0,resourceLoadDuration:0,elementRenderDelay:t.value};if(t.entries.length){const a=t.entries.at(-1),r=a.url&&($.findLast(t=>t.name===a.url)||performance.getEntriesByType("resource").findLast(t=>t.name===a.url));let s;n.target=i.get(a),n.lcpEntry=a,a.url&&(n.url=a.url),r&&(n.lcpResourceEntry=r);let c=0,f=0;if("soft-navigation"!==t.navigationType?(s=e(),c=s?.activationStart??0,f=s?.responseStart??0):(c=t.navigationStartTime||0,s=o.u?.get(t.navigationId)),s){const e=Math.max(0,f-c),o=Math.max(e,r?(r.requestStart||r.startTime)-c:0),i=Math.min(t.value,Math.max(o,r?r.responseEnd-c:0));n={...n,timeToFirstByte:e,resourceLoadDelay:o-e,resourceLoadDuration:i-o,elementRenderDelay:t.value-i,navigationEntry:s}}}return Object.assign(t,{attribution:n})})(n))},n)},t.onTTFB=(t,n={})=>{((t,n={})=>{const o=T(n);let i=b("TTFB"),a=u(t,i,x,n.reportAllChanges);H(()=>{const r=e();if(r){const e=r.responseStart;i.value=Math.max(e-h(),0),i.entries=[r],a(!0),l(()=>{i=b("TTFB",0,"back-forward-cache",i.navigationId,i.navigationInteractionId,i.navigationURL,f()),a=u(t,i,x,n.reportAllChanges),a(!0)}),o&&M(["soft-navigation"],e=>{e.forEach(e=>{e.navigationId&&(i=b("TTFB",0,"soft-navigation",e.navigationId,e.interactionId,e.name,e.startTime),i.entries=[e],a=u(t,i,x,n.reportAllChanges),a(!0))})},n)}})})(n=>{t((t=>{const n=t.entries[0];let e={waitingDuration:0,cacheDuration:0,dnsDuration:0,connectionDuration:0,requestDuration:0,navigationEntry:n};if(t.entries.length&&n instanceof PerformanceNavigationTiming){const o=n.activationStart||0,i=Math.max((n.workerStart||n.fetchStart||0)-o,0),a=Math.max(n.domainLookupStart-o,0),r=Math.max(n.connectStart-o,0),s=Math.max(n.connectEnd-o,0);e={waitingDuration:i,cacheDuration:a-i,dnsDuration:r-a,connectionDuration:s-r,requestDuration:t.value-s,navigationEntry:n}}return Object.assign(t,{attribution:e})})(n))},n)},t}({});
/* ==== theme capture + recipe serving + goals + RUM ==== */
/*
 * PixelPilot theme snippet — SOURCE (funnel capture + recipe serving + goals).
 *
 * This is the AUTHORED logic. It references window.PixelPilotRecipe (the ONE
 * shared apply module, shared/applyRecipe.js). The DEPLOYABLE artifact is
 * generated by `node scripts/build-theme-snippet.js`, which prepends the shared
 * module so the deployed file is self-contained. Never hand-copy applyRecipe in
 * here — edit shared/applyRecipe.js and rebuild.
 *
 * INSTALL (per store): deploy the BUILT file (docs/pixelpilot-capture.built.js),
 * replacing aa805d50005bbfa1e4f3043dbaae57e6 with this store's tenants.public_key, saved as
 * theme asset assets/pixelpilot-capture.js and referenced ONCE in theme.liquid:
 *   <script src="{{ 'pixelpilot-capture.js' | asset_url }}" defer></script>
 * public_key is non-secret (identifies the tenant, like a GA id).
 *
 * oxlint no-undef is ignored for this file (see .oxlintrc.json's
 * ignorePatterns): it runs inside a Shopify theme <script> tag, where
 * `Shopify` and `webVitals` are real runtime globals injected by the theme
 * and the Web Vitals library respectively — not undefined references, just
 * globals this repo's lint environment has no way to know about.
 */
(function () {
  var PUBLIC_KEY = "aa805d50005bbfa1e4f3043dbaae57e6";
  var WEBHOOK  = "https://dashboard.niory.co/api/cro/webhook";
  var RECIPES  = WEBHOOK.replace(/\/webhook$/, "/recipes");

  function device() { return /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop"; }

  // Bot-detection signals (2026-09-30) — sent on every beacon (not just
  // landing) so every funnel-stage row carries the same signal independently;
  // classification happens server-side (lib/attribution/botDetector.js).
  // navigator.webdriver is the one signal a bot can't easily fake without
  // deliberately overriding it — true whenever the page was opened by
  // Selenium/Playwright/Puppeteer-style automation.
  function botSignals() {
    return { user_agent: navigator.userAgent || null, is_webdriver: navigator.webdriver === true };
  }

  // ── Session-ID logic (2026-10-03, aligned to GA4's session-boundary rules) ──
  // A session is reused across pageviews EXCEPT when any of:
  //   1. 30-minute inactivity timeout — more than 30 min since the last time
  //      this snippet ran (GA4's default).
  //   2. Midnight LOCAL-time split — the stored session's calendar day (in
  //      the visitor's own timezone, not UTC) differs from today's.
  //   3. New campaign parameters mid-visit — utm_source/utm_campaign present
  //      on this pageview AND different from the session's recorded values
  //      (a session that started with no UTM, or whose UTM carries through
  //      unchanged, never splits on this rule).
  // sessionStorage persists across pageviews within a tab but not across
  // tabs/browsers, matching GA4's own client-side session model closely
  // enough for funnel/channel reporting purposes.
  //
  // DEGRADED MODE (storage blocked, e.g. Safari ITP full block, a strict
  // extension, or a user privacy setting): every helper below already
  // catches its own storage exception — sessionId() then falls back to a
  // SINGLE id generated once per script evaluation (module-level var, not
  // re-rolled on every call), so a single pageview still reports as exactly
  // one session, never multiple. Each subsequent pageview with storage still
  // blocked necessarily starts a fresh id (nothing persists), which is the
  // correct degrade: session granularity collapses to pageview granularity,
  // it does not multiply beacons within one.
  var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  function localDateKey(d) {
    d = d || new Date();
    return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  }
  function campaignSignature() {
    var s = param("utm_source"), c = param("utm_campaign");
    if (!s && !c) return null; // no campaign params on this pageview -> never trigger rule 3
    return (s || "") + "|" + (c || "");
  }
  function sessionId() {
    var fallback = "s_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
    try {
      var SID_K = "pp_sid", TS_K = "pp_sid_last_ts", DAY_K = "pp_sid_day", UTM_K = "pp_sid_utm";
      var now = Date.now();
      var v = sessionStorage.getItem(SID_K);
      var lastTs = parseInt(sessionStorage.getItem(TS_K) || "0", 10);
      var lastDay = sessionStorage.getItem(DAY_K);
      var lastUtm = sessionStorage.getItem(UTM_K);
      var curUtm = campaignSignature();
      var newSession = !v
        || (now - lastTs) > SESSION_TIMEOUT_MS
        || (lastDay && lastDay !== localDateKey())
        || (curUtm && lastUtm && curUtm !== lastUtm);
      if (newSession) {
        v = fallback;
        sessionStorage.setItem(SID_K, v);
        // A fresh session also resets the "first pageview of this session"
        // flag used for referrer/landing_url capture below.
        try { sessionStorage.removeItem("pp_seen"); } catch (e2) {}
      }
      sessionStorage.setItem(TS_K, String(now));
      sessionStorage.setItem(DAY_K, localDateKey());
      if (curUtm) sessionStorage.setItem(UTM_K, curUtm); // only overwrite when this pageview actually carries campaign params
      return v;
    } catch (e) {
      // sessionStorage unavailable (blocked) -> degrade to one id per
      // pageview (this exact script evaluation), never re-rolled mid-page.
      return fallback;
    }
  }
  function stage() {
    var p = (window.Shopify && Shopify.page && Shopify.page.pageType) || "";
    var path = location.pathname;
    if (p === "product" || /\/products\//.test(path)) return "pdp";
    if (p === "cart" || /\/cart/.test(path)) return "cart";
    if (/\/checkouts?\//.test(path) || /checkout/.test(path)) return "checkout";
    return "landing";
  }
  function param(name) { return new URLSearchParams(location.search).get(name) || null; }

  // ── page_path (2026-10-11, Journeys real-URL upgrade) ────────────────────
  // Normalized pathname sent on EVERY pageview beacon (landingEvent already
  // fires once per page load, see below) — gives Journeys the actual page
  // visited at each step, not just the coarse funnel stage.
  // PARITY: this exact logic is duplicated server-side in
  // lib/attribution/pagePath.js (re-normalized defensively on ingest, never
  // trusting the client alone) — server/scripts/test-page-path-normalize.js
  // runs the same fixture table against both to catch drift. Keep them in
  // sync if either changes.
  // location.pathname never contains the query string or fragment, so
  // there is nothing to strip on that front — this only collapses PII-
  // bearing identifier segments (account/order/checkout tokens) to ':id'.
  var ID_SEGMENT_RE = /^(?:\d{6,}|[0-9a-f]{16,}|[0-9a-zA-Z_-]{24,})$/;
  var CONTENT_ID_SEGMENT_RE = /^(?:\d{6,}|[0-9a-f]{16,})$/;
  var CONTENT_PREFIXES = ["products", "collections", "pages", "blogs", "policies"];
  var PII_PREFIXES = [
    ["account", "orders"], ["account", "addresses"], ["orders"], ["checkouts"], ["cart", "c"],
  ];
  function normalizePagePath(pathname) {
    var segments = (pathname || "").split("/").filter(function (s) { return s; });
    if (!segments.length) return "/";
    var lower = segments.map(function (s) { return s.toLowerCase(); });
    for (var p = 0; p < PII_PREFIXES.length; p++) {
      var prefix = PII_PREFIXES[p], plen = prefix.length, match = true;
      for (var i = 0; i < plen; i++) { if (lower[i] !== prefix[i]) { match = false; break; } }
      if (match && lower.length >= plen) {
        var kept = segments.slice(0, plen);
        if (segments.length > plen) kept.push(":id");
        return "/" + kept.join("/");
      }
    }
    // Merchant-content slugs (/products/<handle> ...) keep their text; only a bare number / bare hex token collapses.
    var inContent = false;
    var out = segments.map(function (s, i) {
      if (CONTENT_PREFIXES.indexOf(lower[i]) !== -1) { inContent = true; return s; }
      return (inContent ? CONTENT_ID_SEGMENT_RE : ID_SEGMENT_RE).test(s) ? ":id" : s;
    });
    return "/" + out.join("/");
  }

  var sid = sessionId();

  function cleanTitle(t) { return String(t || "").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "").slice(0, 160); }
  // /products/<handle> and /collections/<c>/products/<handle> -> <handle> (a merchant slug, not an identifier).
  function handleFromPath(pathname) {
    var segs = (pathname || "").split("/").filter(function (s) { return s; });
    for (var i = 0; i < segs.length - 1; i++) {
      if (segs[i].toLowerCase() === "products") {
        var h = segs[i + 1].toLowerCase();
        return /^[a-z0-9][a-z0-9_-]{0,119}$/.test(h) ? h : null;
      }
    }
    return null;
  }
  // Microsoft Clarity's own session id, from its first-party _clsk cookie ("<sessionId>^<timestamp>^<page>^..." on the live store, "|"-separated in older versions). Read only after analytics consent, and only
  // stored if it has the shape of an id. Lets Journeys point at the right Clarity recording; null when Clarity isn't on the page.
  function clarityId() {
    try {
      var m = /(?:^|; )_clsk=([^;]*)/.exec(document.cookie || "");
      if (!m) return null;
      var v = decodeURIComponent(m[1]).split(/[|^]/)[0];
      return /^[A-Za-z0-9_.-]{1,64}$/.test(v) ? v : null;
    } catch (e) { return null; }
  }

  function eventId() { return "e_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10); }

  // ── Zero-loss delivery (2026-09-29) ─────────────────────────────────────
  // sendBeacon is fire-and-forget: it can't tell success from failure, so a
  // beacon sent during a deploy restart (or any transient network blip) was
  // silently dropped with no way to retry it — confirmed live: a real
  // restart window had a ~4s connection-refused gap with nothing on either
  // side to recover a beacon sent into it. Switched to fetch(keepalive) so
  // failure is observable, queue the event in localStorage on failure, and
  // retry with backoff on the next page load / visibility change. Every
  // event carries a client-generated event_id (deduped server-side via a
  // unique index) so a retry that actually landed the first time — the
  // client just never saw the response — can't double-count.
  var QUEUE_KEY = "pp_queue_v1";
  var MAX_QUEUE = 50; // drop oldest beyond this — a storefront visitor's queue should never realistically grow this large
  var BACKOFF_KEY = "pp_queue_backoff";
  var MIN_RETRY_GAP_MS = 15000; // don't hammer on every visibilitychange in quick succession

  function readQueue() {
    try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch (e) { return []; }
  }
  function writeQueue(q) {
    try { localStorage.setItem(QUEUE_KEY, JSON.stringify(q.slice(-MAX_QUEUE))); } catch (e) { /* storage full/unavailable — best-effort only */ }
  }
  function enqueue(events) {
    var q = readQueue();
    for (var i = 0; i < events.length; i++) q.push(events[i]);
    writeQueue(q);
  }

  function sendBatch(events, onResult) {
    try {
      var body = JSON.stringify({ public_key: PUBLIC_KEY, platform_source: "shopify", events: events });
      fetch(WEBHOOK, { method: "POST", headers: { "Content-Type": "application/json" }, body: body, keepalive: true })
        .then(function (res) { onResult(res.ok); })
        .catch(function () { onResult(false); });
    } catch (e) { onResult(false); }
  }

  // Batch-ready envelope { events:[...] }. Every event gets an event_id here
  // (not per-call-site) so nothing forgets it. On failure, queue for retry
  // instead of dropping.
  function beacon(events) {
    for (var i = 0; i < events.length; i++) if (!events[i].event_id) events[i].event_id = eventId();
    sendBatch(events, function (ok) { if (!ok) enqueue(events); });
  }

  // Flush the retry queue — called on script init (covers "queued during the
  // PREVIOUS page's restart window, user navigated, new page loads normally")
  // and on visibilitychange (covers "tab was backgrounded during the outage,
  // user comes back to it"). Backoff: skip if we tried too recently, so a
  // user bouncing between tabs doesn't hammer a still-down backend.
  function flushQueue() {
    var q = readQueue();
    if (!q.length) return;
    try {
      var last = parseInt(localStorage.getItem(BACKOFF_KEY) || "0", 10);
      if (Date.now() - last < MIN_RETRY_GAP_MS) return;
      localStorage.setItem(BACKOFF_KEY, String(Date.now()));
    } catch (e) { /* proceed anyway if storage read/write fails */ }
    writeQueue([]); // clear optimistically; failed ones get re-enqueued below
    sendBatch(q, function (ok) { if (!ok) enqueue(q); });
  }
  flushQueue();
  try {
    document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") flushQueue(); });
  } catch (e) { /* older browsers without visibilitychange just miss this retry path */ }

  // ── Funnel stage beacon ──────────────────────────────────────────────────
  // click_id collapses every network's click id into ONE column (no schema change;
  // network is inferred later from utm_source — see enrichment.js clickNetwork()).
  // li_fat_id: LinkedIn's click id, delivered as a URL param via the campaign
  // creative's destination-URL macro (same mechanism as fbclid/ttclid/gclid) —
  // NOT the Insight Tag cookie (that's a separate, not-yet-built capture layer;
  // see docs/LINKEDIN-ADS-WIZARD-SPEC.md §7).
  // AI Visibility v2 Section 5 Layer B — capture raw document.referrer + the
  // landing URL on the FIRST pageview of the session only (sessionStorage
  // flag), so an AI engine referral (chatgpt.com, claude.ai, perplexity.ai,
  // gemini.google.com, ...) survives even after the visitor navigates on-site
  // and document.referrer becomes the site's own URL. Server-classified in
  // routes/cro.js (aiReferrer.classifyReferrer) — this snippet just forwards
  // the raw values, no PII, same-origin document.referrer only.
  // ── Own-PSI-call self-tagging at source (2026-10-03) ──────────────────────
  // lib/seo/croSpeedService.js's _fetchPSIOnce appends this marker to the URL
  // it actually asks PageSpeed Insights to render (NOT to the canonical URL
  // stored in cwv_snapshots) — when PSI/Lighthouse renders that URL, this
  // snippet's own real JS runs inside it and sees the marker on
  // location.search. This is GROUND TRUTH at the point of capture, not an
  // after-the-fact inference: the session is tagged psi_source=true here,
  // server-side classified as is_internal/own_psi_call unconditionally (see
  // routes/cro.js), and the marker is STRIPPED before landing_url/referrer
  // are ever stored so it never pollutes URL-based reporting.
  var PSI_MARKER = "_pp_psi";
  function isOwnPsiRender() { return param(PSI_MARKER) === "1"; }
  function stripPsiMarker(href) {
    try {
      var u = new URL(href);
      if (u.searchParams.has(PSI_MARKER)) { u.searchParams.delete(PSI_MARKER); return u.href; }
      return href;
    } catch (e) { return href; }
  }

  // ── Consent gating (Shopify Customer Privacy API, 2026-10-03) ────────────
  // window.Shopify.customerPrivacy.analyticsProcessingAllowed() already
  // encodes Shopify's own region-based consent-requirement logic (EU/UK
  // visitors need opt-in before analytics processing; other regions may not)
  // — this snippet trusts it rather than reimplementing region detection.
  // If the API is absent entirely (an older/non-OS2.0 theme, or customer
  // privacy not enabled in Shopify admin), gating fails OPEN (treated as
  // allowed) — there is nothing to gate ON in that case, and this matches
  // pre-2026-10-03 behavior for stores that haven't adopted the privacy API.
  // If the API IS present but throws, fails CLOSED (treated as not allowed)
  // — safer default for an unexpected error from a consent-relevant call.
  // NO beacon of any kind (funnel, goal, behavior, RUM) fires before consent
  // is confirmed allowed where it's required; queued callbacks run once
  // `visitorConsentCollected` fires and re-confirms allowed — nothing is
  // buffered/sent in the meantime. PSI's own self-tagged render (above) is
  // exempt — it is our own infrastructure, carries no real visitor's
  // personal data, and must always self-identify regardless of a Google
  // datacenter's default consent-API behavior.
  function consentApiPresent() {
    return !!(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function");
  }
  function analyticsAllowed() {
    if (!consentApiPresent()) return true;
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (e) { return false; }
  }
  var _consentQueue = [];
  function onceAnalyticsAllowed(fn) {
    if (analyticsAllowed()) { fn(); return; }
    _consentQueue.push(fn);
  }
  try {
    document.addEventListener("visitorConsentCollected", function () {
      if (!analyticsAllowed()) return;
      var cbs = _consentQueue; _consentQueue = [];
      for (var i = 0; i < cbs.length; i++) { try { cbs[i](); } catch (e) {} }
    });
  } catch (e) { /* older browsers without CustomEvent/addEventListener support just never get the late-consent retry */ }

  // ── Persistent visitor id (Traffic tab new vs returning, 2026-10-03) ─────
  // First-party localStorage id — persists across sessions/tabs, unlike
  // sessionStorage's `sid` above which resets every ~30min/day/new campaign.
  // Consent-gated: only ever read/written from inside an onceAnalyticsAllowed
  // callback (below), same gate as every beacon — a visitor who never
  // consents never gets a persistent id, only ever null visitor_id on their
  // events (excluded from the new/returning split server-side, never
  // guessed). Rotated per policy: a sliding 390-day (13-month) TTL — the
  // common EU ePrivacy-guidance max first-party cookie/storage lifetime,
  // matching the ballpark of GA4's own _ga cookie and Shopify's own
  // _shopify_y cookie — refreshed on every read, so an active visitor's id
  // never lapses but a dormant one eventually rotates (that visitor looks
  // "new" again on return, same as any analytics tool after its own
  // cookie/storage expires — not a bug, a privacy-motivated design choice).
  // DEGRADED MODE (storage blocked): returns null, never fabricates a
  // fresh id per call — a blocked visitor simply has no visitor_id, same
  // treatment as no consent.
  var VISITOR_ID_TTL_MS = 390 * 24 * 60 * 60 * 1000;
  function visitorId() {
    if (!analyticsAllowed()) return null;
    try {
      var VID_K = "pp_vid", VID_TS_K = "pp_vid_ts";
      var now = Date.now();
      var v = localStorage.getItem(VID_K);
      var ts = parseInt(localStorage.getItem(VID_TS_K) || "0", 10);
      if (!v || (now - ts) > VISITOR_ID_TTL_MS) {
        v = "v_" + now.toString(36) + "_" + Math.random().toString(36).slice(2, 12);
        localStorage.setItem(VID_K, v);
      }
      localStorage.setItem(VID_TS_K, String(now));
      return v;
    } catch (e) {
      return null;
    }
  }

  var isFirstPageview = false;
  try {
    if (!sessionStorage.getItem("pp_seen")) { sessionStorage.setItem("pp_seen", "1"); isFirstPageview = true; }
  } catch (e) { isFirstPageview = true; }

  var _psiSource = isOwnPsiRender();

  var landingEvent = {
    session_id: sid, event_type: stage(),
    // utm_medium (2026-09-30, attribution channel-view feature) — was never
    // parsed before; needed to split paid vs organic per channel (a plain
    // utm_source=pinterest with utm_medium=social means an organic Pin, not
    // a Pinterest ad — see lib/attribution/channelClassifier.js).
    utm_source: param("utm_source"), utm_campaign: param("utm_campaign"), utm_variant: param("utm_variant"), utm_medium: param("utm_medium"),
    // utm_content / utm_term (2026-10-22, per-ad attribution): on Meta these are the ad name / ad-set name (url_tags {{ad.name}} / {{adset.name}}).
    utm_content: param("utm_content"), utm_term: param("utm_term"),
    // utm_id / adset_id / ad_id (2026-10-22): the platform's campaign / ad-set / ad IDs (Meta url_tags {{campaign.id}} / {{adset.id}} / {{ad.id}}).
    // IDs survive renames and the ingest quote-stripping that breaks name joins.
    utm_id: param("utm_id"), adset_id: param("adset_id"), ad_id: param("ad_id"),
    click_id: param("fbclid") || param("ttclid") || param("gclid") || param("gbraid") || param("wbraid") || param("li_fat_id"), device_type: device(), geo: null,
  };
  var _bot = botSignals();
  landingEvent.user_agent = _bot.user_agent;
  landingEvent.is_webdriver = _bot.is_webdriver;
  landingEvent.psi_source = _psiSource;
  landingEvent.page_path = normalizePagePath(location.pathname);
  // ── Page identity (2026-10-25, Journeys rebuild) ─────────────────────────
  // WHICH page this was: its own <title> and, on a product page, the product handle. The server drops the title for account/order/checkout
  // paths. event_id is fixed here so the page_exit beacon below can name this page view.
  landingEvent.event_id = eventId();
  landingEvent.page_title = cleanTitle(document.title);
  var _handle = handleFromPath(location.pathname);
  if (_handle) landingEvent.product_handle = _handle;
  if (isFirstPageview) {
    landingEvent.referrer = document.referrer || null;
    landingEvent.landing_url = stripPsiMarker(location.href);
  }
  if (_psiSource) { beacon([landingEvent]); } // our own infra — always self-identifies, never consent-gated, never gets a visitor_id (not a real visitor)
  else { onceAnalyticsAllowed(function () { landingEvent.visitor_id = visitorId(); var cid = clarityId(); if (cid) landingEvent.clarity_session_id = cid; beacon([landingEvent]); }); }

  // ── Goal tracker: theme forms/widgets call window.pixelpilot.track(...) ────
  //   window.pixelpilot.track('email_signup')
  //   window.pixelpilot.track('add_to_cart' | 'checkout_started')
  //   window.pixelpilot.track('custom', 'my_event_name')
  window.pixelpilot = window.pixelpilot || {};
  window.pixelpilot.track = function (type, name) {
    if (!type) return;
    var ev = { session_id: sid, event_type: type, device_type: device() };
    var evBot = botSignals();
    ev.user_agent = evBot.user_agent;
    ev.is_webdriver = evBot.is_webdriver;
    if (type === "custom") { if (!name) return; ev.event_name = String(name); }
    onceAnalyticsAllowed(function () { ev.visitor_id = visitorId(); beacon([ev]); });
  };

  // ── Time on page (2026-10-25, Journeys rebuild) ───────────────────────────
  // Visible milliseconds on THIS page view, reported when the tab is hidden / the page is left. The server writes it onto the page-view row
  // named by page_event_id (it is not an event row of its own). Cumulative, so a page that is hidden and shown again just reports a larger
  // number. Not sent for our own PSI renders. Consent-gated like every other beacon.
  var _shownAt = document.visibilityState === "hidden" ? 0 : Date.now(), _dwell = 0, _exitSent = 0;
  function exitBeacon() {
    if (typeof flushPendingAtc === "function") flushPendingAtc(); // an add still being held (below) must not be lost when the page goes away
    if (_shownAt) { _dwell += Date.now() - _shownAt; _shownAt = 0; }
    if (_psiSource || !_dwell || _dwell === _exitSent) return;
    _exitSent = _dwell;
    var ev = { session_id: sid, event_type: "page_exit", page_event_id: landingEvent.event_id, dwell_ms: Math.min(_dwell, 1800000), device_type: device() };
    onceAnalyticsAllowed(function () {
      var cid = clarityId(); if (cid) ev.clarity_session_id = cid;
      beacon([ev]);
    });
  }
  try {
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") exitBeacon();
      else if (!_shownAt) _shownAt = Date.now();
    });
    window.addEventListener("pagehide", exitBeacon);
  } catch (e) { /* no dwell on browsers without these events */ }

  // ── add_to_cart (2026-10-25, Journeys rebuild) ────────────────────────────
  // The theme never called pixelpilot.track("add_to_cart"), so no add-to-cart was ever recorded (a cart DRAWER never loads /cart either).
  // Capture it where it really happens: the request to /cart/add(.js). fetch and XMLHttpRequest are wrapped to OBSERVE the response (the
  // original promise / request is returned untouched, so the theme behaves exactly as before); a plain HTML form post is caught on submit.
  // One add = one event (800 ms de-dupe across the three paths).
  var CART_ADD_RE = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var CART_CHANGE_RE = /\/cart\/change(\.js|\.json)?(\?|$)/;
  var _lastAtc = 0;
  // Not every POST to /cart/add is a shopper adding something. Mapped from the theme's own flows (2026-10-25):
  //  - swap flow (sections/main-product.liquid): the chosen tier REPLACES the product's lines (change.js to 0, then add). If that add FAILS, the
  //    theme re-adds the lines it removed ("restore") in the same call. A successful add within 3 s of a failed one is that restore: ignored.
  //  - upgrade-to-subscription (cart drawer): the lines are re-added as subscriptions FIRST, then the one-time lines are removed. An add followed
  //    within 1 s by a change.js that sets a quantity to 0 is that upgrade, not a new add: the event is held for 1 s and dropped.
  // The swap flow's own removal comes BEFORE its add, so a real add through it is still counted.
  var ATC_HOLD_MS = 1000, RESTORE_WINDOW_MS = 3000, _addFailAt = 0, _pendingAtc = null;
  // The hold starts the moment the add's RESPONSE arrives (its JSON is read later and filled into the slot), so a change.js that follows right away
  // always finds the add still held, however many promise hops the theme's own code takes in between.
  function holdAtc() {
    if (_pendingAtc) return { item: {} }; // one add = one event: the one already held wins
    var slot = { item: {}, timer: null };
    slot.timer = setTimeout(function () { if (_pendingAtc === slot) { _pendingAtc = null; sendAtc(slot.item); } }, ATC_HOLD_MS);
    _pendingAtc = slot;
    return slot;
  }
  function cancelPendingAtc() { if (_pendingAtc) { clearTimeout(_pendingAtc.timer); _pendingAtc = null; } }
  function flushPendingAtc() { if (_pendingAtc) { clearTimeout(_pendingAtc.timer); var p = _pendingAtc; _pendingAtc = null; sendAtc(p.item); } }
  function removesALine(body) { try { var b = typeof body === "string" ? JSON.parse(body) : null; return !!b && Number(b.quantity) === 0; } catch (e) { return false; } }
  function stampCart() {
    try {
      var lp;
      try { lp = sessionStorage.getItem("pp_landing_path"); if (!lp) { lp = location.pathname; sessionStorage.setItem("pp_landing_path", lp); } }
      catch (e) { lp = location.pathname; }
      fetch("/cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { pp_session_id: sid, _landing_path: lp } }), keepalive: true,
      });
    } catch (e) { /* never break the storefront */ }
  }
  function itemFromCartAdd(j) {
    var it = j && j.items && j.items[0] ? j.items[0] : j;
    if (!it || typeof it !== "object") return {};
    var qty = parseInt(it.quantity, 10);
    var cents = Number(it.final_line_price != null ? it.final_line_price : (it.line_price != null ? it.line_price : (Number(it.price) || 0) * (qty || 1)));
    return {
      handle: typeof it.handle === "string" ? it.handle.toLowerCase() : null,
      title: it.product_title ? cleanTitle(it.product_title) : null,
      qty: qty > 0 && qty < 1000 ? qty : null,
      value: isFinite(cents) && cents >= 0 ? Math.round(cents) / 100 : null,
    };
  }
  function sendAtc(item) {
    var now = Date.now();
    if (now - _lastAtc < 800) return;
    _lastAtc = now;
    item = item || {};
    var ev = { session_id: sid, event_type: "add_to_cart", device_type: device(), page_path: normalizePagePath(location.pathname) };
    var evBot = botSignals();
    ev.user_agent = evBot.user_agent;
    ev.is_webdriver = evBot.is_webdriver;
    var h = item.handle || handleFromPath(location.pathname);
    if (h && /^[a-z0-9][a-z0-9_-]{0,119}$/.test(h)) ev.product_handle = h;
    if (item.title) ev.page_title = item.title;
    if (item.qty) ev.item_qty = item.qty;
    if (item.value != null) ev.item_value = item.value;
    if (_psiSource) return;
    onceAnalyticsAllowed(function () { ev.visitor_id = visitorId(); beacon([ev]); });
    stampCart(); // the cart now exists: make sure it carries this session id for the order / checkout join
  }
  try {
    var _origFetch = window.fetch;
    if (typeof _origFetch === "function") {
      window.fetch = function (input, init) {
        var p = _origFetch.apply(this, arguments);
        try {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          var method = String((init && init.method) || (input && input.method) || "GET").toUpperCase();
          if (method === "POST" && CART_ADD_RE.test(url)) {
            p.then(function (res) {
              if (!res || !res.ok) { _addFailAt = Date.now(); return; }
              if (Date.now() - _addFailAt < RESTORE_WINDOW_MS) return; // the theme putting lines back after a failed add
              var slot = holdAtc();
              res.clone().json().then(function (j) { slot.item = itemFromCartAdd(j); }, function () {});
            }, function () { _addFailAt = Date.now(); }).catch(function () {});
          } else if (method === "POST" && CART_CHANGE_RE.test(url) && removesALine(init && init.body)) {
            cancelPendingAtc(); // the add just before this was an upgrade / swap, not a new add
          }
        } catch (e) {}
        return p;
      };
    }
    var XO = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (XO && XO.open && XO.send) {
      var _xOpen = XO.open, _xSend = XO.send;
      XO.open = function (m, u) { try { this.__ppAtc = String(m).toUpperCase() === "POST" && CART_ADD_RE.test(String(u)); } catch (e) {} return _xOpen.apply(this, arguments); };
      XO.send = function () {
        var x = this;
        try {
          if (x.__ppAtc) x.addEventListener("load", function () {
            if (x.status < 200 || x.status >= 300) { _addFailAt = Date.now(); return; }
            if (Date.now() - _addFailAt < RESTORE_WINDOW_MS) return;
            var j = null; try { j = JSON.parse(x.responseText); } catch (e) {}
            holdAtc().item = itemFromCartAdd(j);
          });
        } catch (e) {}
        return _xSend.apply(this, arguments);
      };
    }
    document.addEventListener("submit", function (ev) {
      try {
        var f = ev.target, a = (f && f.getAttribute && f.getAttribute("action")) || "";
        // A theme that handles the form in JS calls preventDefault and uses fetch (seen above); only a native post is counted here.
        if (CART_ADD_RE.test(a)) setTimeout(function () { if (!ev.defaultPrevented) sendAtc({}); }, 0);
      } catch (e) {}
    }, false);
  } catch (e) { /* never break the storefront */ }

  // ── Clarity tag (2026-10-25, Journeys rebuild) ───────────────────────────────
  // Marks the Microsoft Clarity recording of this visit with OUR session id (custom tag pp_session_id), so Journeys can tell you which recording
  // to filter for. Only when the Clarity tag is on the page, only after analytics consent, and our own PSI renders never do it. A random id, no PII.
  onceAnalyticsAllowed(function () {
    if (_psiSource) return;
    var tries = 0;
    (function tagClarity() {
      try { if (typeof window.clarity === "function") { window.clarity("set", "pp_session_id", sid); return; } } catch (e) { return; }
      if (++tries < 8) setTimeout(tagClarity, 1000);
    })();
  });

  // ── Recipe serving + anti-flicker ─────────────────────────────────────────
  // CAVEAT (by design): the pre-paint hide is applied ONLY for URLs a previous
  // fetch confirmed carry recipes (cached in localStorage). Unknown/no-test URLs
  // are NEVER hidden — so 100% of no-test traffic has zero hide, zero reveal,
  // zero flicker, zero console output. A URL whose test just ended returns empty
  // once, we reveal immediately and clear its cache (self-correcting).
  //
  // ══ PHASE B PRICE TESTING — GOVERNING INVARIANT (contract for the price slices) ══
  // A discounted price is NEVER rendered before the matching discount is CONFIRMED
  // applied on the cart. Concretely, for any recipe containing a priceElement op:
  //   1. FIRST apply the discount for this assigned session (auto-apply the test's
  //      product-scoped Shopify discount) and CONFIRM the cart line/total now equals
  //      op.price.test (within currency rounding). Only THEN reveal the discounted
  //      display (the priceElement setText value).
  //   2. On ANY failure (discount not applied, cart total != price.test, fetch
  //      error, JS/network failure), keep the element HIDDEN of the test value and
  //      show the REAL price (op.price.base) — never charge more than was shown.
  // The op already carries price.base (real) and price.test (intended) exactly so
  // this confirm step can verify checkout before revealing. applyRecipe() only does
  // the DOM apply + fingerprint abort — it does NOT satisfy this invariant on its
  // own; the confirm-before-reveal gate is THIS snippet's responsibility.
  //
  // LEAK MONITOR (design; built in a later slice): the auto-applied discount is a
  // shared product-scoped code, so it can leak to non-assigned traffic (coupon
  // sites). A daily health check compares the discount's redemption count (Admin API
  // codeDiscountNode usageCount) against the test's assigned-cohort conversions; a
  // material excess (redemptions >> cheap-arm conversions) => the code escaped =>
  // auto-PAUSE the price test and alert. This is what makes the shared-code approach
  // acceptable for v1 rather than merely tolerable.
  var CACHE_KEY = "pp_rcache";
  function pageKey() { return (location.host + location.pathname).replace(/\/+$/, "").toLowerCase(); }
  function readCache() { try { return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}"); } catch (e) { return {}; } }
  function writeCache(c) { try { localStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) {} }

  var key = pageKey();
  var cache = readCache();
  var known = cache[key];               // { t:[hideTargets] } if this URL had recipes last time
  var hideEl = null, revealed = false, timer = null;

  function reveal() {
    if (revealed) return; revealed = true;
    if (timer) { clearTimeout(timer); timer = null; }
    if (hideEl && hideEl.parentNode) hideEl.parentNode.removeChild(hideEl);
  }
  function hide(targets) {
    if (!targets || !targets.length) return;
    try {
      hideEl = document.createElement("style");
      hideEl.setAttribute("data-pp-antiflicker", "1");
      hideEl.textContent = targets.map(function (s) { return s + "{visibility:hidden !important}"; }).join("");
      (document.head || document.documentElement).appendChild(hideEl);
      timer = setTimeout(reveal, 800); // hard safety: the page ALWAYS reveals
    } catch (e) { reveal(); }
  }

  // Pre-paint hide ONLY for known-test URLs.
  if (known && known.t && known.t.length) hide(known.t);

  // ── Phase B price testing: confirm-before-reveal + fail-closed policy ───────
  // A price variant serves a priceElement op AND a priceDiscount {code,testPrice,
  // productId}. We NEVER reveal the low price until the CART is confirmed to charge
  // it (the cart is ground truth — the discount merely existing on Shopify does not
  // prove THIS session's cart charges the test price; themes, combinability and
  // other codes interfere). Flow: apply the code to the cart session, read /cart.js,
  // and reveal the low price only if our code is the ONLY discount and the product
  // line's per-unit price == testPrice. Any failure → the real price stays (we
  // simply never apply the price op); the safety timer reveals the real price on
  // time, and a later confirm flips real→low (never low→real, so charged<=shown
  // always). OTHER-DISCOUNT POLICY: a foreign code (welcome / cart-recovery from the
  // abandonment emails) → FAIL CLOSED, do NOT stack, and flag the session excluded.
  function priceParts(recipe) { var price = [], rest = []; (recipe || []).forEach(function (o) { (o && o.priceElement && o.price ? price : rest).push(o); }); return { price: price, rest: rest }; }
  function money(dollars) { return Math.round(Number(dollars) * 100); } // cart.js is cents
  function confirmPriceCart(cart, disc) {
    if (!cart || !cart.items || !cart.items.length) return { ok: false, reason: "no-cart" };
    var apps = (cart.discount_applications || []).concat(cart.cart_level_discount_applications || []);
    var mine = (disc.code || "").toUpperCase();
    for (var a = 0; a < apps.length; a++) { var t = ((apps[a].title || apps[a].code || "") + "").toUpperCase(); if (t && t !== mine) return { ok: false, reason: "other-discount" }; }
    var line = null;
    for (var i = 0; i < cart.items.length; i++) { if (String(cart.items[i].product_id) === String(disc.productId)) { line = cart.items[i]; break; } }
    if (!line) return { ok: false, reason: "no-line" };            // product not in cart → cannot confirm → fail closed
    var per = line.final_price != null ? line.final_price : line.price;
    if (per !== money(disc.testPrice)) return { ok: false, reason: "price-mismatch" };
    return { ok: true };
  }
  function flagExcluded(reason, entry) {
    try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { pp_price_excluded: reason, pp_price_test: String(entry.testId) } }), keepalive: true }); } catch (e) {}
    try { if (window.pixelpilot && window.pixelpilot.track) window.pixelpilot.track("custom", "price_test_excluded_" + reason); } catch (e) {}
  }
  function gatePrice(entry, dev) {
    var disc = entry.priceDiscount, parts = priceParts(entry.recipe);
    fetch("/discount/" + encodeURIComponent(disc.code), { method: "GET", credentials: "same-origin" })
      .then(function () { return fetch("/cart.js", { headers: { Accept: "application/json" } }); })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        var c = confirmPriceCart(cart, disc);
        if (c.ok) { try { window.PixelPilotRecipe.applyRecipe(document, parts.price, { device: dev }); } catch (e) {} } // real → low (safe)
        else flagExcluded(c.reason, entry); // fail closed: real price stays
      })
      .catch(function () { /* fail closed: real price stays */ });
  }

  function applyAll(list) {
    if (!window.PixelPilotRecipe) { reveal(); return; }
    var dev = device(), pending = false;
    for (var i = 0; i < list.length; i++) {
      try {
        // Price entries: apply only the NON-price ops now; the price op is gated on
        // cart confirmation below (never revealed before the cart is confirmed).
        var applyNow = list[i].priceDiscount ? priceParts(list[i].recipe).rest : (list[i].recipe || []);
        var r = window.PixelPilotRecipe.applyRecipe(document, applyNow, { device: dev });
        if (r && r.applied === 0 && applyNow.length) pending = true;
      } catch (e) {}
    }
    // Kick off the async price gates (bounded by the reveal safety timer).
    for (var g = 0; g < list.length; g++) { if (list[g].priceDiscount) gatePrice(list[g], dev); }
    // Late-rendering themes: retry via a short-lived observer, then reveal.
    if (pending && typeof MutationObserver !== "undefined") {
      var obs = new MutationObserver(function () {
        // Re-apply NON-price ops only; the price op stays gated on cart confirmation.
        for (var j = 0; j < list.length; j++) { try { var ro = list[j].priceDiscount ? priceParts(list[j].recipe).rest : (list[j].recipe || []); window.PixelPilotRecipe.applyRecipe(document, ro, { device: dev }); } catch (e) {} }
      });
      try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} reveal(); }, 700);
    } else {
      reveal();
    }
  }

  function onRecipes(list) {
    var withOps = [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].recipe && list[i].recipe.length) withOps.push(list[i]); }
    if (!withOps.length) {
      // Empty / control-only: zero visible effect. Clear stale cache + reveal (no-op if never hid).
      if (cache[key]) { delete cache[key]; writeCache(cache); }
      reveal();
      return;
    }
    var targets = [];
    for (var k2 = 0; k2 < withOps.length; k2++) {
      (withOps[k2].hideTargets || []).forEach(function (s) { if (targets.indexOf(s) < 0) targets.push(s); });
    }
    cache[key] = { t: targets }; writeCache(cache);
    if (!hideEl && targets.length) hide(targets); // first-visit: hide affected regions before applying
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { applyAll(withOps); });
    else applyAll(withOps);
  }

  try {
    fetch(RECIPES, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ public_key: PUBLIC_KEY, session_id: sid, url: location.href, device: device() }),
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { onRecipes((d && d.recipes) || []); })
      .catch(function () { reveal(); }); // network error → reveal, never leave hidden, no noise
  } catch (e) { reveal(); }

  // ── Cart session stamp (order ↔ funnel join) ──────────────────────────────
  stampCart();

  // ── Behavior capture (Phase A): scroll depth + clicks + rage ───────────────
  // Aggregated CLIENT-SIDE — one cumulative summary beacon per page view on
  // visibility-hidden. PRIVACY: selectors + coordinates + counts only, never any
  // input value or text. Password and payment fields are excluded from even
  // selector-level capture. Honors Do-Not-Track (no capture, no beacon at all).
  // 2026-10-03: gated on analytics consent too — listener attachment itself
  // is deferred, not just the outgoing beacon, so nothing is observed pre-
  // consent where consent is required (not merely "collected but unsent").
  onceAnalyticsAllowed(function () {
  try {
    var DNT = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
    if (DNT != "1" && DNT !== "yes") {
      var BEHAVIOR = WEBHOOK.replace(/\/webhook$/, "/behavior");
      var scrollMax = 0, clickCount = 0, clicks = [], selCounts = {}, rage = {};
      var lastSel = null, lastT = 0, streak = 0, st = null;
      function docH() { var b = document.body, d = document.documentElement; return Math.max(b ? b.scrollHeight : 0, d ? d.scrollHeight : 0, 1); }
      function sensitive(el) {
        for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
          var tag = n.tagName, at = n.getAttribute ? (n.getAttribute("type") || "").toLowerCase() : "";
          if (tag === "INPUT" && at === "password") return true;
          var ac = n.getAttribute ? (n.getAttribute("autocomplete") || "").toLowerCase() : "";
          var nm = n.getAttribute ? ((n.getAttribute("name") || "") + " " + (n.id || "")).toLowerCase() : "";
          if (/(^|\s)cc-|cardnumber|creditcard|cvc|cvv/.test(ac) || /card|cvc|cvv|creditcard/.test(nm)) return true;
        }
        return false;
      }
      function stableCls(el) {
        if (!el.className || typeof el.className !== "string") return [];
        return el.className.trim().split(/\s+/).filter(function (c) { return c && c.length < 30 && !/^(is-|has-|js-|active|selected|open|hover|focus)/.test(c); }).slice(0, 2);
      }
      function sel(el) {
        if (!el || el.nodeType !== 1 || sensitive(el)) return null;
        if (el.id && /^[A-Za-z][\w-]*$/.test(el.id)) return "#" + el.id;
        var a = el.attributes;
        for (var i = 0; i < a.length; i++) { if (a[i].name.indexOf("data-") === 0 && a[i].value && a[i].value.length < 40) return el.tagName.toLowerCase() + "[" + a[i].name + "='" + a[i].value.replace(/'/g, "") + "']"; }
        var cls = stableCls(el), base = el.tagName.toLowerCase() + (cls.length ? "." + cls.join(".") : ""), p = el.parentElement;
        if (p) { var same = 0, idx = 0, j; for (j = 0; j < p.children.length; j++) { if (p.children[j].tagName === el.tagName) { same++; if (p.children[j] === el) idx = same; } } if (same > 1) base += ":nth-of-type(" + idx + ")"; }
        return base.slice(0, 160);
      }
      function onScroll() { var h = docH(), pct = Math.round(((window.pageYOffset || 0) + window.innerHeight) / h * 100); if (pct > scrollMax) scrollMax = pct > 100 ? 100 : pct; }
      window.addEventListener("scroll", function () { if (st) return; st = setTimeout(function () { st = null; onScroll(); }, 250); }, { passive: true });
      onScroll();
      document.addEventListener("click", function (e) {
        var s = sel(e.target); if (!s) return;
        clickCount++; selCounts[s] = (selCounts[s] || 0) + 1;
        var h = docH(), y = e.pageY || e.clientY || 0;
        if (clicks.length < 50) clicks.push({ x: e.clientX | 0, y: y | 0, pct: Math.round(y / h * 100), sel: s });
        var now = Date.now();
        if (s === lastSel && now - lastT < 1000) { streak++; if (streak >= 3) rage[s] = (rage[s] || 0) + 1; } else streak = 1;
        lastSel = s; lastT = now;
      }, true);
      var sentAt = 0;
      function sendBehavior() {
        var now = Date.now(); if (now - sentAt < 1500 || (!clickCount && !scrollMax)) return; sentAt = now;
        try {
          var rl = [], r; for (r in rage) if (rage.hasOwnProperty(r)) rl.push({ sel: r, count: rage[r] });
          var body = JSON.stringify({
            public_key: PUBLIC_KEY, session_id: sid, page_path: location.pathname, device: device(),
            viewport: { w: window.innerWidth, h: window.innerHeight }, doc_height: docH(),
            scroll_max_pct: scrollMax, click_count: clickCount, clicks: clicks, click_selectors: selCounts, rage: rl,
          });
          if (navigator.sendBeacon) navigator.sendBeacon(BEHAVIOR, new Blob([body], { type: "application/json" }));
          else fetch(BEHAVIOR, { method: "POST", headers: { "Content-Type": "application/json" }, body: body, keepalive: true });
        } catch (e) { /* never break the storefront */ }
      }
      document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") sendBehavior(); });
      window.addEventListener("pagehide", sendBehavior);
    }
  } catch (e) { /* never break the storefront */ }
  });

  // ── RUM: real-user Core Web Vitals (SEO task 2, 2026-09-30) ────────────────
  // window.webVitals comes from the vendored web-vitals attribution IIFE build
  // (prepended by scripts/build-theme-snippet.js — see that file). Reuses the
  // EXACT zero-loss fetch(keepalive)+localStorage-retry pattern as the funnel
  // beacon above ("Zero-loss delivery" comment) — separate endpoint/queue/
  // payload shape only because RUM samples land in a different table
  // (web_vitals_rum, migration 137) at a different cadence than funnel events;
  // this is the SAME reliability mechanism, not a second one.
  // 2026-10-03: gated on analytics consent, same as the funnel/behavior
  // beacons — the web-vitals observers themselves aren't attached (so
  // nothing is measured, not just unsent) until consent is confirmed
  // allowed. Late consent still captures a usable LCP/CLS/etc reading for
  // web-vitals metrics that fire once per page lifecycle, since the library
  // reports buffered entries on registration even if attached after paint.
  onceAnalyticsAllowed(function () {
  try {
    if (window.webVitals) {
      var RUM = WEBHOOK.replace(/\/webhook$/, "/rum");
      var RUM_QUEUE_KEY = "pp_rum_queue_v1";
      var RUM_BACKOFF_KEY = "pp_rum_queue_backoff";

      var readRumQueue = function () { try { return JSON.parse(localStorage.getItem(RUM_QUEUE_KEY) || "[]"); } catch (e) { return []; } };
      var writeRumQueue = function (q) { try { localStorage.setItem(RUM_QUEUE_KEY, JSON.stringify(q.slice(-MAX_QUEUE))); } catch (e) { /* best-effort only */ } };
      var enqueueRum = function (events) { var q = readRumQueue(); for (var i = 0; i < events.length; i++) q.push(events[i]); writeRumQueue(q); };

      var sendRumBatch = function (events, onResult) {
        try {
          var body = JSON.stringify({ public_key: PUBLIC_KEY, events: events });
          fetch(RUM, { method: "POST", headers: { "Content-Type": "application/json" }, body: body, keepalive: true })
            .then(function (res) { onResult(res.ok); }).catch(function () { onResult(false); });
        } catch (e) { onResult(false); }
      };
      var rumBeacon = function (ev) {
        ev.event_id = eventId();
        sendRumBatch([ev], function (ok) { if (!ok) enqueueRum([ev]); });
      };
      var flushRumQueue = function () {
        var q = readRumQueue();
        if (!q.length) return;
        try {
          var last = parseInt(localStorage.getItem(RUM_BACKOFF_KEY) || "0", 10);
          if (Date.now() - last < MIN_RETRY_GAP_MS) return;
          localStorage.setItem(RUM_BACKOFF_KEY, String(Date.now()));
        } catch (e) { /* proceed anyway */ }
        writeRumQueue([]);
        sendRumBatch(q, function (ok) { if (!ok) enqueueRum(q); });
      };
      flushRumQueue();
      try { document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") flushRumQueue(); }); } catch (e) {}

      var reportVital = function (metric) {
        var ev = {
          url: location.href, device: device(),
          metric_name: metric.name,
          // CLS is a unitless score (fractional, e.g. 0.08) — everything else
          // is milliseconds, safe to round for storage.
          metric_value: metric.name === "CLS" ? metric.value : Math.round(metric.value),
          session_id: sid, user_agent: navigator.userAgent || null,
        };
        // LCP attribution (web-vitals/attribution build only): same shape PSI
        // already gives (timeToFirstByte/resourceLoadDelay/resourceLoadDuration/
        // elementRenderDelay) so the UI never has to reshape lab vs real-user data.
        if (metric.name === "LCP" && metric.attribution) {
          var a = metric.attribution;
          if (a.element) ev.lcp_element = String(a.element).slice(0, 200);
          ev.phase = {
            timeToFirstByte: a.timeToFirstByte, resourceLoadDelay: a.resourceLoadDelay,
            resourceLoadDuration: a.resourceLoadDuration, elementRenderDelay: a.elementRenderDelay,
          };
        }
        rumBeacon(ev);
      };
      // Current web-vitals v6 API (verified against node_modules/web-vitals
      // package.json + its README at install time): onLCP/onINP/onCLS/onTTFB/
      // onFCP, each fired once per page lifecycle by default (no
      // reportAllChanges) — exactly the "one number per visit" shape RUM p75
      // aggregation wants.
      webVitals.onLCP(reportVital);
      webVitals.onINP(reportVital);
      webVitals.onCLS(reportVital);
      webVitals.onTTFB(reportVital);
      webVitals.onFCP(reportVital);
    }
  } catch (e) { /* never break the storefront */ }
  });
})();
